/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const metaAdCampaignStatusSchema = z.enum(['new', 'draft', 'queued', 'pushed', 'ended', 'error'])

export type MetaAdCampaignStatusSchema = z.infer<typeof metaAdCampaignStatusSchema>
